import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store/index'


import login from "../views/login"
import Dlogin from "../views/Dlogin"
import home from "../views/home"
import showhome from "../views/show/showHome"
import noFooterHome from "../views/NofooterHome"
import checkWechat from "../views/checkWechat"
import checkToken from "../views/checkToken"
import checkTokenA from "../views/checkTokenA"


import ResourceDetails from "../views/ResourceDetails"
import CauseAnalysis from "../views/CauseAnalysis.vue";
import SelectCity from "../views/SelectCity.vue";
import ReportsList from "../views/ReportsList/ReportsList.vue";
import AnswerReports from "../views/ReportsList/AnswerReports.vue";
import EditReport from "../views/ReportsList/EditReport.vue";
import ViewReport from "../views/ReportsList/ViewReport.vue";
import SystemSetting from "../views/systemSetting/SystemSetting.vue";
import BaseSetting from "../views/systemSetting/BaseSetting.vue";
import UserSetting from "../views/systemSetting/UserSetting.vue";
import CityMonitor from "../views/CityMonitor/CityMonitor.vue";
import AirQuality from "../views/AirQuality.vue";
import AirRank from "../views/AirRank.vue";
import Wind from "../views/Wind.vue";
import Personal from "../views/Personal/Personal.vue";

import DataPresentation from "../views/DataPresentation/index";
import DataAudit from "../views/DataAudit";
import ThresholdManagement from "../views/ThresholdManagement";

import autoReport from "../views/ReportsList/autoReport";
import pushReport from "../views/ReportsList/pushReport";
import caseReport from "../views/ReportsList/caseReport";
import mobileMonitoring from "../views/ReportsList/mobileMonitoring";

import AIChart from "../views/AIChart";
import villagesSite from "../views/villagesSite";
import stateSite from "../views/stateSite";
import provinceSite from "../views/provinceSite";
import dataStatistic from "../views/dataStatistic";
import StatisticalAnalysis from "../views/StatisticalAnalysis/index";
import GHX_PollutionLevel from "../views/StatisticalAnalysis/GHX_PollutionLevel";
// 案例库
import CaseBase from "../views/CaseBase/index";
import CaseBaseDetails from "../views/CaseBase/caseDetails";


import systemSelection from "../views/systemSelection";
import VOCSystem from "../views/VOCSystem/index";
import VOCSystemHome from "../views/VOCSystem/home/index";
import reverseLonLat from "../views/VOCSystem/home/reverseLonLat";
import VOCIntegrityAnalysis from "../views/VOCSystem/dataQuality/IntegrityAnalysis";
import VOCuniformity from "../views/VOCSystem/dataQuality/VOCuniformity";
import VOCrelevance from "../views/VOCSystem/dataQuality/VOCrelevance";
import Chartrelevance from "../views/VOCSystem/ChartAnalysis/Chartrelevance";

import VOCEffectiveData from "../views/VOCSystem/home/effectiveData";
import VOCregionalConfig from "../views/VOCSystem/set/regionalConfig";
import VOCplanConfig from "../views/VOCSystem/set/planConfig";
import newdataFind from "../views/VOCSystem/home/dataFind";
import dataFindWater from "../views/VOCSystem/home/dataFindWater";
import VOCreportAnalysis from "../views/VOCSystem/report/reportAnalysis";
import VOCchart from "../views/VOCSystem/Chart/chart";
import VOCcomReport from "../views/VOCSystem/VOCcomReport/VOCcomReport";
import VOCreportModify from "../views/VOCSystem/VOCcomReport/reportModify";
import VOCexistingReport from "../views/VOCSystem/VOCcomReport/existingReport";
import VOCHistory from "../views/VOCSystem/set/VOCHistory";
import VOCfixedTime from "../views/VOCSystem/VOCcomReport/fixedTime";
import VOCrealTime from "../views/VOCSystem/VOCcomReport/realTime";
import VOCtemplateAdmin from "../views/VOCSystem/VOCcomReport/templateAdmin";
import VOCTemplateGeneration from "../views/VOCSystem/VOCcomReport/VOCTemplateGeneration";
import timedPush from "../views/VOCSystem/timedPush";
import VOCreportTiming from "../views/VOCSystem/set/reportTiming";


/**
 * 数据分析模块   2024-06-11
 *
 *
 * */

import dataAnalysed from "../views/dataAnalysed/index"
import dataAnalysedHome from "../views/dataAnalysed/home/index"
import dataAnalysedList from "../views/dataAnalysed/home/list"
import dataAnalysedDataFind from "../views/dataAnalysed/home/dataFind"
import dataAChart from "../views/dataAnalysed/dataAChart"
import ReportTaskList from "../views/dataAnalysed/home/ReportTaskList"




Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};

const routes = [
    {
        path: '/',
        name: 'login',
        component: login
    },
    {
        path: '/Dlogin',
        name: 'Dlogin',
        component: Dlogin
    },
    {
        path: '/checkToken/:type',
        name: 'checkToken',
        component: checkToken
    },
    {
        path: '/checkTokenA',
        name: 'checkTokenA',
        component: checkTokenA
    },

    {
        path: '/checkWechat',
        name: 'checkWechat',
        component: checkWechat
    },
    {
        path: '/systemSelection',
        name: 'systemSelection',
        component: systemSelection
    },

    {
        path: '/home',
        name: 'home',
        component: home,
        children: [
            {
                path: 'air-quality',
                name: "AirQuality",
                component: AirQuality
            },
            {
                path: 'air-rank',
                name: "AirRank",
                component: AirRank
            },

            {
                path: 'cause-analysis',
                name: "CauseAnalysis",
                component: CauseAnalysis
            },
            {
                path: 'select-city',
                name: "SelectCity",
                component: SelectCity
            },
            {
                path: 'personal',
                name: "Personal",
                component: Personal
            },
            {
                path: 'StatisticalAnalysis',
                name: "StatisticalAnalysis",
                component: StatisticalAnalysis,
                children:[
                    {
                        path:'GHX_PollutionLevel',
                        name: "GHX_PollutionLevel",
                        component: GHX_PollutionLevel,
                        meta: {name: '光化学污染'},
                    }
                ]
            },
            {
                path: 'report-list',
                name: "ReportsList",
                component: ReportsList,
                children: [
                    {
                        path: 'answer',
                        name: "AnswerReports",
                        component: AnswerReports
                    },
                    {
                        path: 'answer/edit',
                        name: "EditReport",
                        component: EditReport
                    },
                    {
                        path: 'answer/view',
                        name: "ViewReport",
                        component: ViewReport
                    },
                    {
                        path: 'auto',
                        name: "autoReport",
                        component: autoReport
                    },
                    {
                        path: 'case',
                        name: "caseReport",
                        component: caseReport
                    },
                    {
                        path: 'push',
                        name: "pushReport",
                        component: pushReport
                    },
                    {
                        path: 'mobileMonitoring',
                        name: "mobileMonitoring",
                        component: mobileMonitoring
                    }
                ]
            },
            {
                path: 'city-monitor',
                name: "CityMonitor",
                component: CityMonitor
            },
            {
                path: 'ResourceDetails',
                name: "ResourceDetails",
                component: ResourceDetails
            },

            {
                path: 'system-setting/:type',
                name: "SystemSetting",
                component: SystemSetting,
                children: [
                    {
                        path: 'system-setting/base',
                        name: "BaseSetting",
                        component: BaseSetting
                    },
                    {
                        path: 'system-setting/user',
                        name: "UserSetting",
                        component: UserSetting
                    }
                ]
            },
            {
                path: 'villagesSite',
                name: 'villagesSite',
                component: villagesSite
            },
            {
                path: 'stateSite',
                name: 'stateSite',
                component: stateSite
            },
            {
                path: 'provinceSite',
                name: 'provinceSite',
                component: provinceSite
            },
            {
                path: 'dataStatistic',
                name: 'dataStatistic',
                component: dataStatistic
            },
            {
                path: 'DataPresentation',
                name: 'DataPresentation',
                component: DataPresentation
            },
            {
                path: 'DataAudit',
                name: 'DataAudit',
                component: DataAudit
            },
            {
                path: 'ThresholdManagement',
                name: 'ThresholdManagement',
                component: ThresholdManagement
            },
            {
                path: 'CaseBase',
                name: 'CaseBase',
                component: CaseBase
            },
            {
                path: 'CaseBaseDetails',
                name: 'CaseBaseDetails',
                component: CaseBaseDetails
            },
        ]
    },
    {
        path: '/showhome',
        name: 'showhome',
        component: showhome,
        children: [
            {
                path: 'showCaseBase',
                name: "showCaseBase",
                component: ()=>import('../views/show/caseBase')
            },
            {
                path: 'showGHX_PollutionLevel',
                name: "showGHX_PollutionLevel",
                component: ()=>import('../views/show/GHX_PollutionLevel')
            },
        ]
    },
    {
        path: '/Home',
        name: 'Home',
        component: noFooterHome,
        children: [
            {
                path: '/AIChart',
                name: 'AIChart',
                component: AIChart
            },

            {
                path: 'wind',
                name: "Wind",
                component: Wind
            },
        ]
    },
    {
        path: '/VOCSystem',
        name: 'VOCSystem',
        component: VOCSystem,
        children: [
            {
                path: 'VOCSystemHome',
                name: "VOCSystemHome",
                component: VOCSystemHome,
                meta: {name: '数据导入'}
            },
            {
                path: 'newdataFind',
                name: "newdataFind",
                meta: {name: '数据查询'},
                component: newdataFind
            },
            {
                path: 'reverseLonLat',
                name: "reverseLonLat",
                meta: {name: '经纬度逆向'},
                component: reverseLonLat
            },
            {
                path: 'dataFindWater',
                name: "dataFindWater",
                meta: {name: '数据查询'},
                component: dataFindWater
            },
            {
                path: 'VOCEffectiveData',
                name: "VOCEffectiveData",
                meta: {name: '有效数据分析'},
                component: VOCEffectiveData
            },
            {
                path: 'VOCregionalConfig',
                name: "VOCregionalConfig",
                meta: {name: '区域配置'},
                component: VOCregionalConfig
            },
            {
                path: 'VOCplanConfig',
                name: "VOCplanConfig",
                meta: {name: '方案配置'},
                component: VOCplanConfig
            },
            {
                path: 'VOCIntegrityAnalysis',
                name: "VOCIntegrityAnalysis",
                meta: {name: '完整性分析'},
                component: VOCIntegrityAnalysis,
            },
            {
                path: 'VOCuniformity',
                name: "VOCuniformity",
                meta: {name: '一致性分析'},
                component: VOCuniformity
            },
            {
                path: 'VOCrelevance',
                name: "VOCrelevance",
                meta: {name: '相关性分析'},
                component: VOCrelevance
            },
            {
                path: 'Chartrelevance',
                name: "Chartrelevance",
                meta: {name: '图表相关性分析'},
                component: Chartrelevance
            },
            {
                path: 'VOCreportAnalysis',
                name: "VOCreportAnalysis",
                meta: {name: '报告分析'},
                component: VOCreportAnalysis
            },
            {
                path: 'VOCchart',
                name: "VOCchart",
                meta: {name: '专业图表'},
                component: VOCchart
            },
            {
                path: 'VOCcomReport',
                name: "VOCcomReport",
                meta: {name: '综合报告'},
                component: VOCcomReport
            },
            {
                path: 'VOCreportModify',
                name: "VOCreportModify",
                meta: {name: '模板修改'},
                component: VOCreportModify
            },
            {
                path: 'VOCexistingReport',
                name: "VOCexistingReport",
                meta: {name: '报告查询'},
                component: VOCexistingReport
            },
            {
                path: 'VOCHistory',
                name: "VOCHistory",
                meta: {name: '历史记录'},
                component: VOCHistory
            },
            {
                path: 'VOCreportTiming',
                name: "VOCreportTiming",
                meta: {name: '定时任务'},
                component: VOCreportTiming
            },
            {
                path: 'VOCfixedTime',
                name: "VOCfixedTime",
                meta: {name: '定时生成'},
                component: VOCfixedTime
            },
            {
                path: 'VOCrealTime',
                name: "VOCrealTime",
                meta: {name: '实时生成'},
                component: VOCrealTime
            },
            {
                path: 'VOCtemplateAdmin',
                name: "VOCtemplateAdmin",
                meta: {name: '模板管理'},
                component: VOCtemplateAdmin
            },
            {
                path: 'VOCTemplateGeneration',
                name: "VOCTemplateGeneration",
                meta: {name: 'word模板生成'},
                component: VOCTemplateGeneration
            },
           {
                path: 'timedPush',
                name: "timedPush",
                meta: {name: '定时推送'},
                component: timedPush
            },

        ]
    },
    {
        path: '/dataAnalysed',
        name: 'dataAnalysed',
        component: dataAnalysed,
        children:[
            {
                path: 'dataAnalysedHome',
                name: "dataAnalysedHome",
                component: dataAnalysedHome,
                meta: {name: '数据导入'}
            },
            {
                path: 'dataAnalysedList',
                name: "dataAnalysedList",
                component: dataAnalysedList,
                meta: {name: '数据导入记录'}
            },
            {
                path: 'dataAnalysedDataFind',
                name: "dataAnalysedDataFind",
                component: dataAnalysedDataFind,
                meta: {name: '数据查询'}
            },
            {
                path: 'dataAChart',
                name: "dataAChart",
                component: dataAChart,
                meta: {name: '详情'}
            },
            {
                path: 'ReportTaskList',
                name: "ReportTaskList",
                component: ReportTaskList,
                meta: {name: '报告生成器'}
            },

        ]
    }
]
const router = new VueRouter({
    mode: 'history',
    routes
})

// router.beforeEach((to, from, next) => {
//     // console.log(to)
//     if (to.path.indexOf("VOCSystem") != -1) {
//         if (store.state.VOCTagsList && store.state.VOCTagsList.length === 0) {
//             let idName = '6-1'
//
//             if (to.name === 'VOCchart') {
//                 idName = '"chart-' + to.query.id
//             }
//             if (to.name === 'VOCreportAnalysis') {
//                 idName = '"report-' + to.query.id
//             }
//             let data = [{
//                 id: idName,
//                 list: [],
//                 query: `${to.query ? JSON.stringify(to.query) : ''}`,
//                 name: to.meta.name,
//                 routerName: to.name,
//             }]
//             store.commit('updateVOCTagsList', data)
//         }
//     }
//     next()
// })

export default router
